export default (values) => {

  const errors = {};

  if (!values.client_id) errors.client_id = true;
  if (!values.client_site_id) errors.client_site_id = true;

  // Validate uplift_applied_to is required when uplift_percentage is set
  if (values.uplift_percentage > 0 && !values.uplift_applied_to) {
    errors.uplift_applied_to = 'Required when uplift is set';
  }

  // Validate fields in update context

  return errors;

}
